import classNames from 'classnames/bind';
import React from 'react';
import { useSelector } from 'react-redux';

import Summary from './01_Summary';
import Items from './02_Items';
import Chart from './03_Chart';
import Empty from './04_Empty';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const Mission = () => {
  const targetRobotIds = useSelector((state) => state.robot.targetRobotIds);
  const commands = useSelector((state) => state.missions[targetRobotIds[0]]?.commands);

  // 선택 로봇이 1개가 아닌 경우
  if (targetRobotIds.length !== 1) return;

  return (
    <div className={cx('container')}>
      {commands && (
        <>
          <Summary data={commands} />
          <Items data={commands} />
          <Chart data={commands} />
        </>
      )}
      {!commands && <Empty />}
    </div>
  );
};

export default Mission;
